import React from "react";
import PropTypes from "prop-types";

function MobileHeader({itemLabel, parentItemLabel}) {
  return (
    <div className="mobileHeader">
      <div className="headerTextBlock">
        {parentItemLabel && <div className="parentItemLabel">{parentItemLabel}</div>}
        <div className="subHeader">Select a {itemLabel}.</div>
      </div>
    </div>
  );
}

MobileHeader.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  parentItemLabel: PropTypes.string
};

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/PlacebarDropdown/MobileHeader.jsx